<template>
  <div>
    <modal-loading
      v-if="isLoading"
      :openModal="isLoading"
      :value="100"
      :variant="'white'"
      :animated="false"
      :label="'carregando...'"
    ></modal-loading>

    <div v-if="!isOnline" class="barraoffline">
      <span
        class="w-100 text-center"
        style="vertical-align: middle; color: white"
      >
        Dispositivo Offline
      </span>
    </div>

    <div class="barrasuperior" v-if="false">
      <span class="w-100 d-block text-center" style="vertical-align: middle">
        <img
          src="img/janoo-logo-v2-high-color.png"
          style="max-width: 180px; height: auto"
          class="justify-content-center align-items-center display-flex"
        />
      </span>
    </div>

    <!--  BREADCRUMB  -->
    <div class="mb-2 d-flex justify-content-center">
      <b-breadcrumb
        rounded
        style="background-color: #ffffff; width: fit-content"
        class="fixed-breadcrumb"
      >
        <b-breadcrumb-item
          class="pl-3"
          :disabled="breadcrumbItems.showIngressosForm"
          :active="!breadcrumbItems.showIngressosForm"
        >
          1. ingressos e data
        </b-breadcrumb-item>

        <b-breadcrumb-item
          :disabled="breadcrumbItems.showDadosForm"
          :active="!breadcrumbItems.showDadosForm"
        >
          2. dados
        </b-breadcrumb-item>

        <b-breadcrumb-item
          class="pr-2"
          :disabled="breadcrumbItems.showPaymentForm"
          :active="!breadcrumbItems.showPaymentForm"
        >
          3. resumo
        </b-breadcrumb-item>
      </b-breadcrumb>
    </div>
    <!--  BREADCRUMB  -->

    <div class="product-content-area">
      <div class="maininfo">
        <div v-if="!isLoading" v-show="breadcrumbItems.showIngressosForm">
          <div class="maininfotext">
            <div class="column1">
              <div class="column-title mb-4">quantas pessoas?</div>
              <ingressos-form
                :PAYMENT_STATUS="PAYMENT_STATUS"
                :isLoading="isLoading"
                :atrativos="poisList"
                :reservationBlocked="reservationBlocked"
                @resetPaymentStatus="resetPaymentStatus"
                @goToSection="defineSection"
              >
              </ingressos-form>
            </div>

            <div class="column2">
              <div class="column-title mb-4">
                {{ QUOTE_TODAY ? 'para hoje' : 'quando?' }}
              </div>
              <div class="d-flex justify-content-center w-100">
                <CalendarForm
                  @goToSection="defineSection"
                  @blockReservation="reservationBlocked = $event"
                  @show-calendar="showConfirmedCalendar"
                  :payLater="form.payLater"
                  :HIDE_CALENDAR="HIDE_CALENDAR"
                ></CalendarForm>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!isLoading && breadcrumbItems.showDadosForm">
          <dados-form
            :PAYMENT_STATUS="PAYMENT_STATUS"
            :AUTO_CHECKIN="AUTO_CHECKIN"
            @resetPaymentStatus="resetPaymentStatus"
            @goToSection="defineSection"
            :poisList="poisList"
          >
          </dados-form>
        </div>

        <!-- <div v-show="breadcrumbItems.showPaymentForm">
                    <modal-resumo-reserva
                        :PAYMENT_STATUS="PAYMENT_STATUS"
                        @goToSection="defineSection"
                        @resetPaymentStatus="resetPaymentStatus">
                    </modal-resumo-reserva>
                </div> -->

        <div v-show="false">
          <!-- MUST BE PRESENT BUT NOT VISIBLE      :USER_UUID="USER_UUID"  -->
          <atrativo-carrosel
            :PLACE_UUID="''"
            :atrativos="poisList"
            :place_public_data="place_public_data"
            @goToSection="defineSection"
          >
          </atrativo-carrosel>
        </div>
      </div>

      <div v-if="form.atrativo.product_place_name && !isLoading">
        <div class="atrativocard">
          <!--  <HelpCard :isLoading="isLoading"></HelpCard> -->
          <AtrativoCard :isLoading="isLoading"></AtrativoCard>
        </div>
        <ResumoReserva :isLoading="isLoading"></ResumoReserva>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AtrativoCarrosel from './AtrativoCarrosel'
import IngressosForm from './IngressosForm'
import DadosForm from './DadosForm'
import HelpCard from './HelpCard.vue'
import AtrativoCard from './AtrativoCard.vue'
import ResumoReserva from './ResumoReserva.vue'
import ModalResumoReserva from './ModalResumoReserva.vue'
import CalendarForm from './CalendarForm.vue'
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'
import { computed } from 'vue'
import router from '../../routes/router'
import store from './store'
import swal from 'sweetalert2'
import moment from 'moment'

export default {
  name: 'ReservaExpressaPage',

  components: {
    AtrativoCarrosel,
    IngressosForm,
    DadosForm,
    AtrativoCard,
    HelpCard,
    CalendarForm,
    ModalResumoReserva,
    ResumoReserva,
    ModalLoading,
  },

  data() {
    return {
      breadcrumbItems: {
        showCarroselAtrativos: false,
        showIngressosForm: true,
        showDadosForm: false,
        showPaymentForm: false,
      },
      PLACE_UUID: '',
      USER_UUID: '',
      PRODUCT_UUID: '',
      PAYMENT_STATUS: null,
      DEVICE: '',
      AUTO_CHECKIN: false,
      QUOTE_TODAY: false,
      SHOW_BOOKING_TYPE: false,
      HIDE_CALENDAR: false,
      reservationBlocked: false,
      isLoading: true,
      isOnline: navigator.onLine,
      bcVersion: process.env.VUE_APP_VERSION,
      product: null,
      queryPlaceUuid: '',
      confirmedBookingDate: '',
      fromModal: false,
    }
  },
  provide() {
    return {
      isOnline: computed(() => this.isOnline),
    }
  },

  computed: {
    ...mapGetters('booking', {
      form: 'getReservaForm',
      place_public_data: 'getPlacePublicData',
    }),
    ...mapGetters('product', {
      poisList: 'getPois',
    }),
  },

  watch: {
    PAYMENT_STATUS(newValue, oldValue) {
      if (newValue != null && newValue != undefined) {
        this.toDadosForm()
      }
    },
  },

  methods: {
    ...mapActions('booking', ['bookingStoreCommit', 'fetchPlacePublicData']),

    ...mapActions('operacao', ['resetBillItemDetails']),

    ...mapActions('product', ['fetchPOIs']),

    defineSection(section) {
      if (section == 'ingressos') {
        this.toIngressosForm()
      }
      if (section == 'dados') {
        this.toDadosForm()
      }
      if (section == 'atrativos') {
        this.goToSalesPage()
      }
      // if(section == 'payment'){ this.toPaymentForm() }
    },

    placeUuidFromProduct(product) {
      if (!product) return ''
      return (
        product.place_uuid ||
        product.placeUUID ||
        product.placeUuid ||
        product.product_place ||
        product.product_place_uuid ||
        ''
      )
    },

    resolveSalesPlaceUuid() {
      if (this.queryPlaceUuid) return this.queryPlaceUuid
      const fromProduct = this.placeUuidFromProduct(this.product)
      if (fromProduct) return fromProduct
      return this.placeUuidFromProduct(this.form && this.form.atrativo)
    },

    goToSalesPage() {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(
          { type: 'close-express-booking' },
          window.location.origin
        )
        return
      }
      if (this.fromModal) {
        this.$router.back()
        return
      }
      const placeUuid = this.resolveSalesPlaceUuid()
      if (!placeUuid) return
      const date = this.confirmedBookingDate
      const path = date
        ? `/public-bookings/${placeUuid}/${date}`
        : `/public-bookings/${placeUuid}`
      window.location.assign(path)
    },

    parseBookingDate(value) {
      if (!value || typeof value !== 'string') return ''
      const parsed = moment(value, 'YYYY-MM-DD', true)
      return parsed.isValid() ? parsed.format('YYYY-MM-DD') : ''
    },

    showConfirmedCalendar() {
      this.HIDE_CALENDAR = false
    },

    resetPaymentStatus(status) {
      this.PAYMENT_STATUS = status
    },

    toIngressosForm() {
      this.breadcrumbItems.showIngressosForm = true
      this.breadcrumbItems.showDadosForm = false
      this.breadcrumbItems.showPaymentForm = false
    },

    toDadosForm() {
      this.breadcrumbItems.showIngressosForm = false
      this.breadcrumbItems.showDadosForm = true
      this.breadcrumbItems.showPaymentForm = false
    },

    // toPaymentForm(){
    //     this.breadcrumbItems.showIngressosForm = false
    //     this.breadcrumbItems.showDadosForm = false
    //     this.breadcrumbItems.showPaymentForm = true
    // },

    async loadPublicData() {
      const UUID =
        this.PLACE_UUID == undefined || this.PLACE_UUID == null
          ? null
          : this.PLACE_UUID
      if (UUID) {
        await this.fetchPlacePublicData(UUID).finally(() => {})
      }
    },

    updateOnlineStatus(event) {
      this.isOnline = event.type == 'online'
    },

    checkFreeBooking() {
      var totalQuantity = this.form.tickets.reduce(
        (prev, curr) => prev + curr.quantity,
        0
      )
      var currentTotalCost = this.form.tickets.reduce(
        (prev, curr) => prev + Number(curr.quantity * curr.price),
        Number(0)
      )

      if (currentTotalCost == 0 && totalQuantity > 0) {
        this.form.free_booking = true
      } else {
        this.form.free_booking = false
      }
    },
  },

  async created() {
    this.resetBillItemDetails()
    this.form.free_booking = false
    this.form.payLater = false
    let queryData = JSON.parse(atob(Object.keys(this.$route.query)[0]))
    this.fromModal = !!queryData.from_modal
    this.queryPlaceUuid =
      queryData.place_uuid != undefined && queryData.place_uuid != null
        ? String(queryData.place_uuid)
        : ''
    this.PRODUCT_UUID =
      queryData.product_uuid != undefined && queryData.product_uuid.length > 0
        ? queryData.product_uuid
        : ''
    this.form.payLater = queryData.paylater ? true : false
    await this.fetchPOIs({
      PLACE_UUID: this.PLACE_UUID,
      PRODUCT_UUID: this.PRODUCT_UUID,
    })

    await this.loadPublicData()
    if (this.poisList.length == 0) {
      swal
        .fire({
          title: 'Erro',
          text: 'Erro ao carregar a reserva',
          icon: 'error',
          showConfirmButton: false,
          allowOutsideClick: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        .then(() => {
          this.$router.push('/dashboard/index')
        })
    }

    this.product = this.poisList.find((poi) => poi.uuid === this.PRODUCT_UUID)
    if (
      queryData.paylater &&
      this.product &&
      this.product.quotationsale == false
    ) {
      delete queryData.paylater
      delete queryData.quote_today
      this.form.payLater = false
      const encoded = btoa(JSON.stringify(queryData))
      this.$router.replace(`/booking/?${encoded}`).catch(() => {})
    }
    this.PAYMENT_STATUS =
      this.$route.query.status != null && this.$route.query.status != 'null'
        ? this.$route.query.status
        : null
    this.DEVICE = queryData.device == 'toten' ? 'TOTEM' : null
    this.QUOTE_TODAY = queryData.quote_today ? true : false
    this.AUTO_CHECKIN = this.QUOTE_TODAY
      ? false
      : queryData.auto_checkin
      ? true
      : false
    this.form.auto_checkin = this.AUTO_CHECKIN
    this.$set(this.form, 'auto_checkin_blocked', false)
    this.$set(this.form, 'quote_today', this.QUOTE_TODAY)
    // this.CAN_PAYLATER = queryData.paylater ? true : false
    this.SHOW_BOOKING_TYPE = queryData.show_booking_type ? true : false
    this.HIDE_CALENDAR =
      queryData.HIDE_CALENDAR || this.AUTO_CHECKIN || this.QUOTE_TODAY
        ? true
        : false
    if (this.QUOTE_TODAY) {
      this.form.date = moment().format('YYYY-MM-DD')
    }
    const bookingDate = this.parseBookingDate(queryData.booking_date)
    if (bookingDate && !this.QUOTE_TODAY && !this.AUTO_CHECKIN) {
      this.confirmedBookingDate = bookingDate
      this.$set(this.form, 'booking_date', bookingDate)
      this.form.date = bookingDate
      this.HIDE_CALENDAR = true
    } else {
      this.confirmedBookingDate = ''
      this.$set(this.form, 'booking_date', '')
    }

    // console.log('PRODUCT_UUID', this.PRODUCT_UUID)
    // console.log('PLACE_UUID', this.PLACE_UUID)
    // console.log('PAYMENT_STATUS', this.PAYMENT_STATUS)
    // console.log('DEVICE', this.DEVICE)
    // console.log('AUTO_CHECKIN', this.AUTO_CHECKIN)
    // console.log('CAN_PAYLATER', this.form.payLater)
    // console.log('SHOW_BOOKING_TYPE', this.SHOW_BOOKING_TYPE)
    // console.log('HIDE_CALENDAR', this.HIDE_CALENDAR)

    this.isLoading = false
    try {
    } catch (error) {
      this.$router.push('/dashboard/index')
    }
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)

    if (
      process.env.NODE_ENV !== 'production' ||
      this.$route.query.debug == 'true'
    ) {
      window.jdebug = this
    }

    if (!this.PRODUCT_UUID) {
      swal.fire({
        title: 'Erro',
        text: 'Link de reserva inválido',
        icon: 'error',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      return
    }
    this.product = this.poisList.find((poi) => poi.uuid === this.PRODUCT_UUID)
    if (!this.queryPlaceUuid) {
      this.queryPlaceUuid = this.placeUuidFromProduct(this.product)
    }
    if (!this.product) {
      swal.fire({
        title: 'Erro',
        text: 'Link de reserva inválido',
        icon: 'error',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      return
    }
    this.checkFreeBooking()
  },

  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  },
}
</script>
<style>
.column1 {
  min-width: 450px;
}

.column-title {
  font-size: 14px;
  font-weight: 500;
  color: #000;
  margin-bottom: 5px;
  text-align: left;
  padding-left: 10px;
  border-left: 2px solid;
  border-color: #aaa;
}

.fixed-breadcrumb {
  position: fixed;
  padding: 8px;
  margin-top: 30px;
  z-index: 999;
  /*   box-shadow:  0 5px 10px rgba(0, 0, 0, 0.079) ; */
  /* padding-bottom: 0.5%; */
}

.fixed-breadcrumb li {
  display: inline;
  margin-right: 10px;
}

.product-content-area {
  display: flex;
  justify-content: center;
  margin-top: 100px;
  margin-bottom: 100px;
  align-items: top;
  padding-right: 30px;
  padding-left: 30px;
}

.barrasuperior {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 55px;
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 100%;
  background-color: white;
  border-bottom: 1px solid #b0b0b0;
  z-index: 10;
  display: flex;
  align-items: center;
}

.barraoffline {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 25px;
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 100%;
  background-color: black;
  border-bottom: 1px solid #000;
  z-index: 20;
  display: flex;
  align-items: center;
}

.barraoffline:visible {
  top: 25px;
}

.maininfo {
  width: 800px;
  height: fit-content;
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 12px;
  padding-top: 25px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 35px;
}

.maininfotext {
  display: flex;
}

@media screen and (max-width: 1280px) {
  .fixed-breadcrumb {
    margin-top: 10px;
  }

  .product-content-area {
    display: flex;
    justify-content: center;
    margin-top: 60px;
    margin-bottom: 80px;
  }

  .maininfo {
    padding-bottom: 20px;
  }
}

@media screen and (max-width: 980px) {
  .maininfotext {
    flex-direction: column;
  }
}

@media screen and (max-width: 870px) {
  .fixed-breadcrumb {
    padding: 8px 0;
    margin-top: 5px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.079);
  }

  .atrativocard {
    display: flex;
    justify-content: center;
  }

  .fixed-breadcrumb li {
    margin-right: 5px;
    font-size: 13px;
  }

  .product-content-area {
    display: flex;
    flex-direction: column-reverse;
    margin-top: 50px;
    margin-bottom: 150px;
  }

  .maininfotext {
    display: block;
  }

  .maininfo {
    width: 100%;
    margin: 0;
    height: auto;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    border-radius: 12px;
    padding: 20px;
  }

  .column1 {
    min-width: 300px;
  }
  .column2 {
    min-width: 300px;
  }

  .column2 .b-calendar,
  .column2 .b-calendar .b-calendar-inner {
    width: 100% !important;
  }
}

@media screen and (max-width: 400px) {
  .resumoreserva {
    margin-bottom: 65px;
    left: 5%;
  }

  .column1 {
    min-width: 240px;
  }
  .column2 {
    min-width: 240px;
  }

  .column2 .b-calendar,
  .column2 .b-calendar .b-calendar-inner {
    width: 100% !important;
  }
}
</style>
